import { ButtonBase, Typography, Link } from "@mui/material"
import React from "react"

import { navigate } from "gatsby-link"

const ButtonStyled = (props) => {
  const { route, text, topGutterSpacing, bottomGutterSpacing, external } = props

  // Handle click
  const handleClick = () => {
    if (route && !external) {
      navigate(route)
    }
    return
  }

  const buttonStyle = {
    marginTop: topGutterSpacing || 0,
    marginBottom: bottomGutterSpacing || 0,
    paddingLeft: 2,
    paddingRight: 2,
    paddingTop: 1,
    paddingBottom: 1,
    fontSize: `1rem`,
    border: `1px solid #263847`,
    textDecoration: `none`,
    color: `titles.main`,
    textTransform: `uppercase`,
    "&:hover": {
      backgroundColor: `titles.main`,
      color: `background.light`,
      border: `1px solid transparent`,
      opacity: 1,
    },
  }

  return (
    <>
      {external ? (
        <Link sx={buttonStyle} href={route}>
          {text}
        </Link>
      ) : (
        <ButtonBase
          onClick={() => {
            handleClick()
          }}
          sx={{
            marginTop: topGutterSpacing || 0,
            marginBottom: bottomGutterSpacing || 0,
            paddingLeft: 2,
            paddingRight: 2,
            paddingTop: 1,
            paddingBottom: 1,
            fontSize: `1rem`,
            border: `1px solid #263847`,
            borderColor: "borders",
            color: `titles.main`,
            textTransform: `uppercase`,
            "&:hover": {
              backgroundColor: `titles.main`,
              color: `background.light`,
              border: `1px solid transparent`,
              opacity: 1,
            },
          }}
        >
          <Typography variant="monoMedium">{text}</Typography>
        </ButtonBase>
      )}
    </>
  )
}

export default ButtonStyled
